export default __webpack_public_path__ + "static/media/home.3a3a4ae3.svg";